<template>
  <draggable ref="draggable"
             :value="items"
             :move="canBeDragged"
             :disabled="isDisabled"
             @change="changeOrder"
             @start="setIsDragging(true)"
             @end="setIsDragging(false)">
    <slot></slot>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },

  props: {
    disableIndex: {
      type: Number,
      default: -1
    },
    items: {
      type: Array,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    // vs-collapse-item calls this.$parent.emitChange() , expecting its parent is vs-collapse. In this case his parent
    // is draggable, so it just needed to have some method emitChange to prevent js errors.
    this.$refs.draggable.emitChange = this.emitChange
  },

  methods: {
    emitChange() {
      this.$emit('change')
    },
    canBeDragged(event) {
      if (this.disableIndex > -1) {
        const { index, futureIndex } = event.draggedContext
        return index !== this.disableIndex && futureIndex !== this.disableIndex // returning false will cancel the drag operation
      }

      return true
    },

    setIsDragging(isDragging) {
      this.$emit('is-dragging', isDragging)
    },

    changeOrder(event) {
      const { oldIndex, newIndex } = event.moved
      this.$emit('change-order', oldIndex, newIndex)
    }
  }
}
</script>
